import React from "react";
import { Chip } from "@mui/material";
import BlockRoundedIcon from "@mui/icons-material/BlockRounded";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import PersonOffRoundedIcon from "@mui/icons-material/PersonOffRounded";

// Shared status chip for a project assignment's capacity (used on the Resource
// Calendar/Management "Assigned Projects" tables): Fully Booked / Active / Pending.
function CapacityStatusChip({ capacityPercent }) {
  const capacity = capacityPercent || 0;

  if (capacity >= 100) {
    return (
      <Chip
        icon={<BlockRoundedIcon />}
        label="Fully Booked"
        size="small"
        color="error"
        variant="outlined"
      />
    );
  }

  if (capacity > 0) {
    return (
      <Chip
        icon={<AssignmentIndRoundedIcon />}
        label="Allocated"
        size="small"
        color="success"
        variant="outlined"
      />
    );
  }

  return (
    <Chip
      icon={<PersonOffRoundedIcon />}
      label="Not Allocated"
      size="small"
      variant="outlined"
    />
  );
}

export default CapacityStatusChip;
